var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "dashboard-block" }, [
    _c("div", { staticClass: "row row-clear-sm-6-md-4" }, [
      _c(
        "div",
        {
          class: _vm.$paymentsModuleEnabled ? `col-sm-6 col-md-4` : `col-sm-6`,
        },
        [
          _c("div", { staticClass: "dashboard-widget-overview" }, [
            _vm.$costReferences && _vm.widgets.pending_total && !_vm.$isAflClub
              ? _c("span", { staticClass: "amount" }, [
                  _vm._v(
                    _vm._s(
                      _vm._f("currency")(
                        _vm.widgets.pending_total,
                        _vm.widgets.currency
                      )
                    )
                  ),
                ])
              : _vm._e(),
            _vm._v(
              "\n        " +
                _vm._s(_vm.widgets.pending_count) +
                " Pending " +
                _vm._s(_vm.$t("Requests")) +
                " this week\n      "
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          class: _vm.$paymentsModuleEnabled ? `col-sm-6 col-md-4` : `col-sm-6`,
        },
        [
          _c("div", { staticClass: "dashboard-widget-overview" }, [
            _vm.$costReferences &&
            _vm.widgets.completed_total &&
            !_vm.$isAflClub
              ? _c("span", { staticClass: "amount" }, [
                  _vm._v(
                    _vm._s(
                      _vm._f("currency")(
                        _vm.widgets.completed_total,
                        _vm.widgets.currency
                      )
                    )
                  ),
                ])
              : _vm._e(),
            _vm._v(
              "\n        " +
                _vm._s(_vm.widgets.completed_count) +
                " Completed Bookings this week\n      "
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          class: _vm.$paymentsModuleEnabled ? `col-sm-6 col-md-4` : `col-sm-6`,
        },
        [
          _c("div", { staticClass: "dashboard-widget-overview" }, [
            _vm.$costReferences && _vm.widgets.active_total && !_vm.$isAflClub
              ? _c("span", { staticClass: "amount" }, [
                  _vm._v(
                    _vm._s(
                      _vm._f("currency")(
                        _vm.widgets.active_total,
                        _vm.widgets.currency
                      )
                    )
                  ),
                ])
              : _vm._e(),
            _vm._v(
              "\n        " +
                _vm._s(_vm.widgets.active_count) +
                " Active Bookings this week\n      "
            ),
          ]),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _vm.haveVettingTalent
        ? _c(
            "div",
            { class: [_vm.vettingTalentAndManagersClass] },
            [
              _c(
                "router-link",
                {
                  staticClass: "btn btn-block btn-default-outline",
                  attrs: {
                    to: {
                      name: "talent.index",
                      params: { status: "unverified" },
                    },
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.widgets.vetting_talent) +
                      " Unverified " +
                      _vm._s(_vm.$starLabelPlural) +
                      " Pending "
                  ),
                  _c("i", { staticClass: "fa fa-chevron-right" }),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.haveVettingManagers
        ? _c(
            "div",
            { class: [_vm.vettingTalentAndManagersClass] },
            [
              _c(
                "router-link",
                {
                  staticClass: "btn btn-block btn-default-outline",
                  attrs: {
                    to: {
                      name: "managers.index",
                      params: { status: "unverified" },
                    },
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.widgets.vetting_managers) +
                      " Unverified Managers Pending "
                  ),
                  _c("i", { staticClass: "fa fa-chevron-right" }),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }